import { defineStore } from 'pinia';

export const useRecipeStore = defineStore('recipe', {
    state: () => ({
        amount: 0,
        possibleAmounts: [],
    }),
    actions: {
        setAmount(amount) {
            this.amount = amount;
        },
        setPossibleAmounts(amounts) {
            this.possibleAmounts = amounts;
        },
    },
});
